import React, { useEffect, useState } from "react"
import axios from "axios"
import baseURL from "../Url/Url.jsx"
import { useNavigate } from "react-router-dom"
import SideBarAdmin from "../Layout/SideBarAdmin.jsx";

const AdminUserManagement = () => {
    const navigate = useNavigate()

    const [users, setUsers] = useState([])
    const [msg, setMsg] = useState("")
    const [usernameMode, setUsernameMode] = useState("select")
    const [perusahaanMode, setPerusahaanMode] = useState("select")
    const [estateMode, setEstateMode] = useState("select")
    const [expandedUsers, setExpandedUsers] = useState({});
    
    const [form, setForm] = useState({
        userName: "",
        password: "",
        confPassword: "",
        perusahaan: "",
        ktp: "",
        namaLengkap: "",
        role: "user",
        status: ""
    })

    // get user/admin
    const getUsers = async () => {
        const res = await axios.get(`${baseURL}/admin/users`)
        const mapped = res.data.map(u => ({
            ...u,
            password: "",
            confPassword: ""
        }))
        setUsers(mapped)
    }

    useEffect(() => {
        const checkAdmin = async () => {
            try {
                await axios.get(`${baseURL}/admin/users`, {
                    withCredentials: true
                })
                getUsers()
            } catch (error) {
                console.log("Bukan admin / session habis")
                window.location.href = "/adm13n"
            }
        }
        checkAdmin()
    }, [])    

    useEffect(() => {
        if (!msg) return
        const timer = setTimeout(() => {
            setMsg("")
        }, 3000)
        return () => clearTimeout(timer)
    }, [msg])
    

    // register user/admin
    const registerAdmin = async (e) => {
        e.preventDefault()
        try {
            await axios.post(`${baseURL}/usersBE`, form)
            setMsg(`${form.role === "admin" ? "Admin" : "User"} berhasil ditambahkan`)
            setForm({
                userName: "",
                password: "",
                confPassword: "",
                perusahaan: "",
                ktp: "",
                namaLengkap: "",
                role: "user",
                status: ""
            })
            getUsers()
        } catch (error) {
            setMsg(error.response?.data?.msg || "Gagal")
        }
    }

    // update user/admin
    const updateUser = async (id, data) => {
        await axios.patch(`${baseURL}/admin/users/${id}`, data)
        getUsers()
    }

    // delete user/admin
    const deleteUser = async (id, userName) => {
        const confirmDelete = window.confirm(
            `Yakin ingin menghapus akun "${userName}" ?`
        )
        if (!confirmDelete) return
    
        try {
            await axios.delete(`${baseURL}/admin/users/${id}`)
            setMsg("User berhasil dihapus")
            getUsers()
        } catch (error) {
            setMsg(error.response?.data?.msg || "Gagal menghapus user")
        }
    }    

    // update handle
    const handleUserChange = (id, field, value) => {
        setUsers(users.map(u =>
            u.id === id ? { ...u, [field]: value } : u
        ))
    }
    
    // logout
    const logout = async () => {
        await axios.delete(`${baseURL}/logoutBE`)
        navigate("/adm13n", { replace: true })
    }

    // GROUPING USERNAME
    const groupedUsers = Object.values(
        users.reduce((acc, user) => {
            if (!acc[user.userName]) {
                acc[user.userName] = {
                    userName: user.userName,
                    role: user.role,
                    companies: []
                }
            }
            acc[user.userName].companies.push({
                id: user.id,
                perusahaan: user.perusahaan,
                status: user.status
            })

            return acc
        }, {})
    )

    // expand field
    const toggleExpand = (userName) => {
        setExpandedUsers(prev => ({
            ...prev,
            [userName]: !prev[userName]
        }));
    };

    return (
        <div id="wrapper">
            {/* SIDEBAR ADMIN */}
            <SideBarAdmin/>
            {/* CONTENT */}
            <div id="content-wrapper">
                {/* NAVBAR */}
                <nav className="navbar navbar-expand-sm sticky-top nav-bar py-3">
                    <div className="container">
                        <h5 className="fw-bold m-0">Manajemen User Admin</h5>
                        <button onClick={logout} className="btn btn-logout">
                            <i className="bi bi-power"></i>
                        </button>
                    </div>
                </nav>
                {/* KONTEN */}
                <div className="container-fluid m-0 p-0" style={{height:"80vh", width:"100%"}}>
                    <div className="row justify-content-center overflow-auto pb-4">
                        <div className="col-12 px-5">
                            <h5 className="fw-bold text-center mt-4">Tambah User / Admin</h5>
                            <div className="box p-4 mt-4">
                                {msg && <p className="text-danger text-center">{msg}</p>}
                                <form onSubmit={registerAdmin}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="input-group mb-4">
                                                {usernameMode === "select" ? (
                                                    <select className="form-control form" value={form.userName} onChange={e => {
                                                        const value = e.target.value;
                                                        if (value === "__manual__") {setUsernameMode("input");setForm({...form,userName: "",ktp: "",namaLengkap: ""});return;}const user = users.find(u => u.userName === value);setForm({...form,userName: value,ktp: user?.ktp || "",namaLengkap: user?.namaLengkap || ""});}}required>
                                                        <option value="">-- Pilih Username --</option>
                                                        {[...new Set(users.map(u => u.userName))].map(userName => (<option key={userName} value={userName}>{userName}</option>))}
                                                        <option value="__manual__">➕ Input Manual</option>
                                                    </select>
                                                ) : (
                                                    <input type="text" className="form-control form"placeholder="Input Username"value={form.userName}onChange={e =>setForm({ ...form, userName: e.target.value })}required/>
                                                )}
                                                <button type="button"className="btn"title={usernameMode === "select"? "Input manual": "Pilih dari daftar"}onClick={() => {setUsernameMode(usernameMode === "select" ? "input" : "select");setForm({ ...form, userName: "" });}}>
                                                    {usernameMode === "select" ? "✏️" : "📋"}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="input-group mb-4">
                                                {perusahaanMode === "select" ? (
                                                    <select className="form-control form" value={form.perusahaan} onChange={e => {if (e.target.value === "__manual__") {setPerusahaanMode("input");setForm({ ...form, perusahaan: "" });} else {setForm({ ...form, perusahaan: e.target.value });}}}required>
                                                        <option value="">-- Pilih Perusahaan --</option>
                                                        {[...new Set(users.map(u => u.perusahaan?.trim()).filter(Boolean))].map(perusahaan => (
                                                           <option key={perusahaan} value={perusahaan}>
                                                                {perusahaan}
                                                            </option>
                                                        ))}
                                                        <option value="__manual__">➕ Input Manual</option>
                                                    </select>
                                                ) : (
                                                    <input type="text" className="form-control form"placeholder="Input Perusahaan"value={form.perusahaan}onChange={e =>setForm({ ...form, perusahaan: e.target.value })}required/>
                                                )}
                                                <button type="button"className="btn  no-focus"title={perusahaanMode === "select"? "Input manual": "Pilih dari daftar"}onClick={() => {setPerusahaanMode(perusahaanMode === "select" ? "input" : "select");setForm({ ...form, perusahaan: "" });}}>
                                                    {perusahaanMode === "select" ? "✏️" : "📋"}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <select className="form-control form mb-4"value={form.role}onChange={e => setForm({ ...form, role: e.target.value })}>
                                                <option value="user">User</option>
                                                <option value="admin">Admin</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3">
                                            {/* <input className="form-control form mb-4"placeholder="Estate"value={form.status}onChange={e => setForm({ ...form, status: e.target.value })}required/> */}
                                            <div className="input-group mb-4">
                                                {estateMode === "select" ? (
                                                    <select className="form-control form" value={form.status} onChange={e => {if (e.target.value === "__manual__") {setEstateMode("input");setForm({ ...form, status: "" });} else {setForm({ ...form, status: e.target.value });}}}required>
                                                        <option value="">-- Pilih Estate --</option>
                                                        {[...new Set(
                                                            users
                                                                .filter(u => {
                                                                    // Jika perusahaan dipilih, ambil status yang sesuai perusahaan tersebut
                                                                    // Jika perusahaan kosong, ambil semua status yang tersedia
                                                                    return form.perusahaan 
                                                                        ? u.perusahaan === form.perusahaan 
                                                                        : true;
                                                                })
                                                                .map(u => u.status?.trim())
                                                                .filter(Boolean)
                                                        )].map(status => (
                                                        <option key={status} value={status}>
                                                                {status}
                                                            </option>
                                                        ))}
                                                        <option value="__manual__">➕ Input Manual</option>
                                                    </select>
                                                ) : (
                                                    <input type="text" className="form-control form"placeholder="Input Estate"value={form.status}onChange={e =>setForm({ ...form, status: e.target.value })}required/>
                                                )}
                                                <button type="button"className="btn  no-focus"title={estateMode === "select"? "Input manual": "Pilih dari daftar"}onClick={() => {setEstateMode(estateMode === "select" ? "input" : "select");setForm({ ...form, status: "" });}}>
                                                    {estateMode === "select" ? "✏️" : "📋"}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <input type="password"className="form-control form mb-4"placeholder="Password"value={form.password}onChange={e => setForm({ ...form, password: e.target.value })}required/>
                                        </div>
                                        <div className="col-md-3">
                                            <input type="password"className="form-control form mb-4"placeholder="Konfirmasi Password"value={form.confPassword}onChange={e => setForm({ ...form, confPassword: e.target.value })}required/>
                                        </div>
                                        <div className="col-md-3">
                                            <input className="form-control form mb-4"placeholder="KTP"value={form.ktp}onChange={e => setForm({ ...form, ktp: e.target.value })}required/>
                                        </div>
                                        <div className="col-md-3">
                                            <input className="form-control form mb-4"placeholder="Nama Lengkap"value={form.namaLengkap}onChange={e => setForm({ ...form, namaLengkap: e.target.value })}required/>
                                        </div>
                                    </div>
                                    <button className="btn btn-webew-login mt-3">Tambah {form.role === "admin" ? "Admin" : "User"}</button>
                                </form>
                            </div>
                        </div>
                        <div className="col-12 px-5">
                            <h5 className="fw-bold text-center mt-5">Daftar User / Admin</h5>
                            <div className="box p-4 mt-4 table-responsive" style={{height:"470px"}}>
                                <div style={{overflow:"auto"}}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Username</th>
                                                <th>Perusahaan</th>
                                                <th>Estate</th>
                                                <th>Role</th>
                                                <th>Password Baru</th>
                                                <th>Konf. Password</th>
                                                <th>Aksi</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {groupedUsers.map(u => {
                                                const isExpanded = expandedUsers[u.userName];
                                                // Ambil hanya data pertama jika tidak di-expand
                                                const displayCompanies = isExpanded ? u.companies : [u.companies[0]];
                                                const remainingCount = u.companies.length - 1;
                                    
                                                return (
                                                <tr key={u.userName} style={{borderBottom:"1px solid rgb(113, 113, 113)"}}>
                                                    <td className={`pb-2 align-top`}>
                                                        <input value={u.userName}onChange={e => handleUserChange(u.id, "userName", e.target.value)}className="form-control form" style={{fontSize:"9pt", minWidth:"80px"}}/>
                                                    </td>
                                                    <td className="pb-2 px-2">
                                                        {displayCompanies.map((c, index) => (
                                                            <div key={c.id} className="my-0 py-0">
                                                                <input value={c.perusahaan}onChange={e => handleUserChange(c.id, "perusahaan", e.target.value)}className="form-control form" style={{fontSize:"9pt", minWidth:"220px"}}/>
                                                                {!isExpanded && remainingCount > 0 && index === 0 && (
                                                                    <small className="text-primary mt-1 d-block" style={{ cursor: 'pointer', fontWeight: 'bold' }}onClick={() => toggleExpand(u.userName)}>+{remainingCount} lainnya...</small>
                                                                )}
                                                            </div>
                                                        ))}
                                                        {isExpanded && (
                                                            <small className="text-primary d-block mt-1" style={{ cursor: 'pointer', fontWeight: 'bold' }}onClick={() => toggleExpand(u.userName)}>Sembunyikan</small>
                                                        )}
                                                    </td> 
                                                    <td className="pb-2 align-top">
                                                        {displayCompanies.map((c, index) => (
                                                            <div key={c.id} className="m-0">
                                                                <input value={c.status}onChange={e => handleUserChange(c.id, "status", e.target.value)}className="form-control form" style={{fontSize:"9pt", minWidth:"60px"}}/>
                                                            </div>
                                                        ))}
                                                    </td>
                                                    <td className="pb-2 px-2 align-top">
                                                        <select value={u.role}onChange={e => {const newRole = e.target.value; u.companies.forEach(c =>handleUserChange(c.id, "role", newRole))}}className="form-control form" style={{fontSize:"9pt", minWidth:"60px"}}>
                                                            <option value="user">User</option>
                                                            <option value="admin">Admin</option>
                                                        </select>
                                                    </td>
                                                    <td className="pb-2 align-top"> 
                                                        {displayCompanies.map((c, index) => (
                                                            <div key={c.id} className="my-0 py-0">
                                                                <input value={c.password}onChange={e => handleUserChange(c.id, "password", e.target.value)}className="form-control form" style={{fontSize:"9pt"}}/>
                                                            </div>
                                                        ))}
                                                    </td>
                                                    <td className="pb-2 px-2 align-top">
                                                        {displayCompanies.map((c, index) => (
                                                            <div key={c.id} className="my-0 py-0">
                                                                <input value={c.confPassword}onChange={e => handleUserChange(c.id, "confPassword", e.target.value)}className="form-control form" style={{fontSize:"9pt"}}/>
                                                            </div>
                                                        ))}
                                                    </td>
                                                    <td className="align-top">
                                                        {displayCompanies.map((c) => (
                                                            <div key={c.id} className="d-flex gap-1 my-0 py-0">
                                                                <button className="btn px-1 text-primary"title="Simpan" style={{paddingTop:"7px"}}
                                                                    onClick={async () => {
                                                                        try {
                                                                            const current = users.find(us => us.id === c.id);
                                                                            await updateUser(c.id, {
                                                                                userName: current.userName,
                                                                                perusahaan: current.perusahaan,
                                                                                role: current.role,
                                                                                status: current.status,
                                                                                password: current.password || undefined,
                                                                                confPassword: current.confPassword || undefined
                                                                            });
                                                                            alert(`Data PT "${c.perusahaan}" berhasil disimpan`);
                                                                            await getUsers();
                                                                            window.location.reload();
                                                                        } catch (error) {
                                                                            alert("Gagal menyimpan data");
                                                                        }
                                                                    }}
                                                                >
                                                                    <i className="bi bi-save"></i>
                                                                </button>
                                                                <button className="btn px-1 text-danger"title="Hapus" style={{paddingTop:"7px"}} onClick={() => deleteUser(c.id, `${u.userName} - ${c.perusahaan}`)}>
                                                                    <i className="bi bi-trash"></i>
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </td>
                                                </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminUserManagement
